import React from 'react'
import { Typography } from '@mui/material'
import { CloudTypeEnum, type CloudType } from '../../types'
import { useStyles } from './OnboardingHeaderTitleBar.styles'
import aws from '../../images/aws.png'
import azure from '../../images/azure.png'

export type OnboardingHeaderTitleBarProps = {
  title?: string
  cloudType?: CloudType
}

const cloudLogos: Partial<Record<CloudType, string>> = {
  [CloudTypeEnum.AWS]: aws,
  [CloudTypeEnum.AZURE]: azure,
}

export const OnboardingHeaderTitleBar: React.FC<
  OnboardingHeaderTitleBarProps
> = ({ title, cloudType }) => {
  const { classes } = useStyles()
  const logo = cloudType ? cloudLogos[cloudType] : undefined
  return (
    <div className={classes.container}>
      <div className={classes.upperContainer}>
        <Typography data-testid="wrapper-title" className={classes.title}>
          {title}
        </Typography>
      </div>
      {logo && (
        <div className={classes.image}>
          <img
            className={classes.logo}
            src={logo}
            alt={cloudType}
            data-testid="cloud-logo"
          />
        </div>
      )}
    </div>
  )
}
